import Error from "../_error";
import dynamic from "next/dynamic";

import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";
import { hasProperty } from "../../utils/validate";

const ProductDisplayPage = dynamic(() => import('../../components/Pages/ProductDisplayPage'));
const productType = "motorcycles";

const ProductPage = (props) => {
	const { slug, token } = props;

	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager([productType], [slug, token]),
		queryFn: () => getQueryFn(`${productType}/${slug}`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error')){
		return <Error error={data.error} errorCode={data.error.code}  />
	}

	return (
		<ProductDisplayPage
			category={productType}
			data={data}
		/>
	);
};

ProductPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { slug, token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager([productType], [slug, token]),
		queryFn: () => getQueryFn(`${productType}/${slug}`, token),
		...queryConfig
	});
	return {
		slug: slug,
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default ProductPage;
